import {Button} from '@wandb/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React, {FC, useState} from 'react';
import {toast} from 'react-toastify';

import {useGenerateApiKeyMutation} from '../generated/graphql';
import {GenerateApiKeyMutationData} from '../graphql/users';
import {extractErrorMessageFromApolloError} from '../util/errors';
import {
  DEFAULT_API_KEY_DESCRIPTION,
  NewApiKeyConfirmation,
} from './CreateApiKeyDrawer';
import * as S from './WBModal.styles';

type GenerateApiKeyButtonProps = {
  asText?: boolean;
  trackingEvent?: () => void;
};

export const GenerateApiKeyButton: FC<GenerateApiKeyButtonProps> = ({
  asText = false,
  trackingEvent = () => {},
}) => {
  const [generateApiKeyData, setGenerateApiKeyData] = useState<any>(null);
  const [generateApiKeyMutation] = useGenerateApiKeyMutation();
  const [isNewApiKeyModalOpen, setIsNewApiKeyModalOpen] =
    useState<boolean>(false);

  const generateApiKey = async () => {
    try {
      const result = await generateApiKeyMutation({
        variables: {
          description: DEFAULT_API_KEY_DESCRIPTION,
        },
      });
      setGenerateApiKeyData(result.data);
      setIsNewApiKeyModalOpen(true);
      trackingEvent();
    } catch (err) {
      toast(extractErrorMessageFromApolloError(err));
    }
  };

  return (
    <div>
      {asText ? (
        <span onClick={generateApiKey}>Generate</span>
      ) : (
        <Button size="md" startIcon="key-admin" onPress={generateApiKey}>
          Generate new API key
        </Button>
      )}
      {generateApiKeyData && (
        <NewApiKeyModal
          isOpen={isNewApiKeyModalOpen}
          close={() => setIsNewApiKeyModalOpen(false)}
          generateApiKeyData={generateApiKeyData}
        />
      )}
    </div>
  );
};

type NewApiKeyModalProps = {
  isOpen: boolean;
  close: () => void;
  generateApiKeyData: GenerateApiKeyMutationData;
};

const NewApiKeyModal: FC<NewApiKeyModalProps> = ({
  isOpen,
  close,
  generateApiKeyData,
}) => {
  const apiKeyData = generateApiKeyData?.generateApiKey;
  const copyApiKey = () => {
    if (apiKeyData?.secretApiKey) {
      navigator.clipboard.writeText(apiKeyData.secretApiKey);
      toast.success('API key copied to clipboard');
    }
    close();
  };
  return (
    <S.WBModal open={isOpen} onClose={close} width="min(600px, 90vw)">
      <Tailwind>
        <S.WBModalHeader>Your new API key</S.WBModalHeader>
        <S.WBModalContent>
          <NewApiKeyConfirmation generateApiKeyData={generateApiKeyData} />
        </S.WBModalContent>
        <S.WBModalActions>
          <Button size="md" onPress={copyApiKey}>
            Copy and close
          </Button>
        </S.WBModalActions>
      </Tailwind>
    </S.WBModal>
  );
};
